import { render, staticRenderFns } from "./loan-contract.vue?vue&type=template&id=2d934069&scoped=true"
import script from "./loan-contract.vue?vue&type=script&lang=js"
export * from "./loan-contract.vue?vue&type=script&lang=js"
import style0 from "./loan-contract.vue?vue&type=style&index=0&id=2d934069&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d934069",
  null
  
)

export default component.exports